import {api} from "./api";


export const giftApi={
    getGifts: () => api.get("/api/gifts-list"),
    exChangeGifts : (data) => api.post("/api/exchange-gifts", data)
}